import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowforwardFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.797 18.813a1.15 1.15 0 0 1 0-1.626L13.983 12 8.797 6.813a1.15 1.15 0 0 1 1.626-1.626l6 6c.449.449.449 1.177 0 1.626l-6 6a1.15 1.15 0 0 1-1.626 0",
    clipRule: "evenodd"
  }));
}
var IcArrowforwardFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowforwardFill));

export { IcArrowforwardFill as I };
